import { runInAction } from 'mobx';
import { createFilledArray } from '../../../../utils/array-utils';
import { getItemById } from '../../../sales-data/selectors/items/get-item-by-id';
import { isNormalItem } from '../../../sales-data/utils/items/item-type-utils';
import { getInProgressItem } from '../../selectors/items/get-in-progress-item';
import { getInProgressItemCount } from '../../selectors/items/get-in-progress-item-count';
import { temporaryOrderDomainStore } from '../../temporary-store/store';
import { createInProgressItem } from './create-in-progress-item';
import { createInProgressItemWithPrice } from './create-in-progress-item-with-price';
export const updateInProgressItemQuantity = (sellableItem, quantity, itemPrice) => {
    if (!getInProgressItemCount()) {
        const item = getItemById(sellableItem.itemId);
        if (!item)
            throw new Error(`Cannot find item with ID: ${sellableItem.itemId}.`);
        if (isNormalItem(item))
            createInProgressItemWithPrice(sellableItem, itemPrice);
        else
            createInProgressItem(sellableItem);
    }
    const inProgressItem = getInProgressItem();
    if (!inProgressItem) {
        throw new Error('Cannot update in-progress item quantity without an in-progress item.');
    }
    runInAction(() => {
        temporaryOrderDomainStore.data.inProgressItems = createFilledArray(inProgressItem, quantity);
    });
};
